import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private translocoService = inject(TranslocoService);


  private readonly LANG_KEY = 'user_lang';

  constructor() {
    this.loadInitialLanguage();
  }

  getSavedLanguage(): string | null {
    return window.localStorage.getItem(this.LANG_KEY);
  }

  loadInitialLanguage(): void {
    const savedLang = this.getSavedLanguage();
    const defaultLang = 'en'; // or whatever your default language is
    this.setLanguage(savedLang || defaultLang);
  }

  switchLanguage() {
    const lang = (this.translocoService.getActiveLang() === 'en') ? 'fr' : 'en';
    this.setLanguage(lang);
  }

  private setLanguage(lang: string) {
    this.translocoService.setActiveLang(lang);
    window.localStorage.setItem(this.LANG_KEY, lang);
  }
}
